import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = BaseButtonProps & {
    isSelected?: boolean;
    variant?: 'default' | 'sidebar';
    isSmallFont?: boolean;
};

export const ParkingSlotButton = ({ children, isSelected, variant = 'default', isSmallFont, ...props }: Props) => {
    return (
        <BaseButton
            {...props}
            className={clsx(
                styles['parking-slot-button'],
                isSelected && styles['parking-slot-button--selected'],
                variant === 'sidebar' && styles['parking-slot-button--sidebar']
            )}
        >
            <span
                className={clsx(
                    styles['parking-slot-button__label'],
                    isSmallFont && styles['parking-slot-button__label--small']
                )}
            >
                {children}
            </span>
        </BaseButton>
    );
};
